import md5 from 'md5'

export function getSign(params, isJsonContent) {
  // 签名
  const SIGNKEY = 'sjdxfnqogbzoun13d971ckh8p'
  let headers = {}
  let paramValStr = ''
  let timestamp = new Date().getTime()
  if (params && typeof params === 'object') {
    if (isJsonContent) {
      paramValStr = JSON.stringify(params)
      headers['Content-Type'] = 'application/json'
    } else {
      const sortedObjKeys = Object.keys(params).sort()
      for (let index in sortedObjKeys) {
        let val = params[sortedObjKeys[index]]
        paramValStr += val
      }
    }
  }
  let signature = md5(`${SIGNKEY}${paramValStr}${timestamp}`)
  headers.signature = signature
  headers.timestamp = timestamp
  return headers
}

export function getSignSecure(params, isJsonContent) {
  // 签名
  const SIGNKEY = 'c34ecaca44ba4f1a8ee98561965476bf'
  let headers = {}
  let paramValStr = ''
  let valueArr = []
  let timestamp = new Date().getTime()
  if (params && typeof params === 'object') {
    if (isJsonContent) {
      paramValStr = JSON.stringify(params)
      headers['Content-Type'] = 'application/json'
      let signature = md5(`${SIGNKEY + paramValStr + timestamp}`)
      headers.signature = signature
      headers.timestamp = timestamp
      return headers
    } else {
      let sortedObjKeys = Object.values(objKeySort(params))
      for (let index in sortedObjKeys) {
        valueArr.push(sortedObjKeys[index])
      }
      let signature = md5(`${SIGNKEY}${valueArr.join('')}${timestamp}`)
      headers.signature = signature
      headers.timestamp = timestamp
      return headers
    }
  }
}

export function createQlSignGet(params) {
  let valueArr = []
  const signStr = 'fe6ab37e4fc644d1a118ddff54793083'
  if (params) {
    let sortedObj = Object.values(objKeySort(params))
    for (let index in sortedObj) {
      valueArr.push(sortedObj[index])
    }
  }
  let timestamp = new Date().getTime()
  const sign = md5(signStr + valueArr.join('') + timestamp)
  return {
    signature: sign,
    timestamp,
    appcode: 'com.rjhy.uranus',
  }
}

const objKeySort = (arys) => {
  var newkey = Object.keys(arys).sort()
  var newObj = {}
  for (var i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = arys[newkey[i]]
  }
  return newObj
}

// 删除url中某个参数,并跳转
export const removeParam = (key, sourceURL) => {
  if (!sourceURL.includes('?')) return sourceURL
  var rtn = sourceURL.split('?')[0],
    param,
    params_arr = [],
    queryString = sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : ''
  if (queryString !== '') {
    params_arr = queryString.split('&')
    for (var i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split('=')[0]
      if (param === key) {
        params_arr.splice(i, 1)
      }
    }
    rtn = rtn + '?' + params_arr.join('&')
  }
  return rtn
}

export function getParameterByName(name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export function setTitle(t) {
  document.title = t;
  var i = document.createElement('iframe');
  i.src = '//upload.techgp.cn/h5-lowcode-render/render/spread/favicon.ico';
  i.style.display = 'none';
  i.onload = function() {
    setTimeout(function() {
      i.remove();
    }, 9);
  };
  document.body.appendChild(i);
}

export function getEnvironment() {
  const ua = navigator.userAgent.toLowerCase()
  const isWeixin = ua.match(/MicroMessenger/i) == 'micromessenger'
  
  if (!isWeixin) {
    return '其他环境'
  }
  
  if (typeof window !== 'undefined' && window.__wxjs_environment === 'miniprogram') {
    return '微信小程序环境'
  }
  
  if (ua.includes('miniprogram')) {
    return '微信小程序环境'
  }
  
  return '微信浏览器环境'
}
